import { FormikErrors } from 'formik'
import { useModalControl } from '../../hooks/useModalControl'
import { CreateProductValues } from '../../redux-toolkits/products/products.type'
import { ActionChip } from '../cards/actionChip'
import { EditInput } from '../inputs/editInput'
import { SelectSubCategoriesModal } from '../modal/app_modals/selectSubCategoriesModal'
import { HeaderSubheader } from '../typography/HeaderSubheader'

export const ManageProductSubCategories = ({
  values,
  setFieldValue,
  errors,
  typeTitle,
}: {
  values: CreateProductValues
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean,
  ) => Promise<void> | Promise<FormikErrors<CreateProductValues>>
  errors?: string
  typeTitle: string
}) => {
  const { handleModalOpen, setModalOpen, modal, modalOpen, handleModalClose } =
    useModalControl()

  return (
    <div className="flex flex-col gap-6 pb-10 border-b border-divider-gray">
      <HeaderSubheader
        title={`${typeTitle} Subcategories`}
        text={`Specify ${typeTitle} subcategories`}
        className="w-full md:w-fit"
      />

      <EditInput
        title={`Subcategories`}
        value={undefined}
        onEditClick={() => {
          handleModalOpen('selectSubCategoriesModal')
        }}
        errors={errors}
        onCancel={() => {}}
        onEditSave={() => {}}
        editing={false}
        className={'col-span-full'}
      >
        {() => {
          return (
            <div className="flex flex-row gap-4 items-center flex-wrap">
              {values.subCategory.map((subCategory, idx) => {
                const key = `subcat-${idx}`
                return (
                  <ActionChip
                    key={key}
                    name={subCategory.name}
                    icon={subCategory.icon}
                  />
                )
              })}
            </div>
          )
        }}
      </EditInput>

      <SelectSubCategoriesModal
        open={modalOpen && modal === 'selectSubCategoriesModal'}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
        }}
        onSuccessCallback={(subCategory) => {
          setFieldValue('subCategory', subCategory)
          handleModalClose()
        }}
        selectedSubCategories={values.subCategory}
        categories={values.category.map((cat) => cat._id)}
      />
    </div>
  )
}
